import FullRender from './FullRender';
import withInfiniteScroll from '../../../../HOC/withInfiniteScroll';
export default withInfiniteScroll(FullRender);
//# sourceMappingURL=FullRenderWithInfiniteScroll.js.map